import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScrollToTopOnMount from '../../helpers/ScrollToTopOnMount/ScrollToTopOnMount';

const ClickErrorPage = () => {
  return (
  <div className="click-error-page">
    <div className="container container--md"><FormattedMessage id="click-error-page.message" defaultMessage="This flow is inactive"/></div>
  </div>
  )
};

export default ClickErrorPage;
